import React, { Component } from "react";
import MessagesTable from "../MessagesTable/MessagesTable";
import Preloader from "../../shared/items/static/preloader";
import { states } from "../../reducers/queriesStates";
import { withMessages } from "../../shared/containers/containerMessages";
import { withTimerangeIntelligence } from "../../shared/containers/containerTimerangeIntelligence";
import { withMapPositions } from "../../shared/containers/containerMapPositions";
import { withIntelligenceTimeRangePlayer } from "../../shared/containers/containerIntelligenceTimeRangePlayer";
import { withIntelligenceControl } from "../../shared/containers/containerIntelligenceControl";
import { withMapControl } from "../../shared/containers/containerMapControl";

class MessagesData extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoaded: false, messagesData: null };
  }

  componentDidMount() {
    const { messagesDataState, onGetMessages, carId, startDate, endDate } = this.props;

    if (messagesDataState === states.READY) {
      this.setState({ isLoaded: true });
    } else {
      onGetMessages({
        carId,
        startDate,
        endDate,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { messagesDataState, mapPositionsDataState, onGetMessages, carId, startDate, endDate } = this.props;
    const { isLoaded } = this.state;

    if (mapPositionsDataState === states.REQUEST && isLoaded) {
      this.setState({ isLoaded: false });
    }

    if (mapPositionsDataState === states.READY && prevProps.mapPositionsDataState === states.REQUEST) {
      onGetMessages({
        carId,
        startDate,
        endDate,
      });
    }

    if (prevProps.messagesDataState === states.REQUEST && messagesDataState === states.READY) {
      this.setState({ isLoaded: true });
    }
  }

  handleClickRow(date) {
    const { onSetCurrentPoint, mapPoints, onSetMessagesSelectDateDataState, onSetMapCenter } = this.props;

    const index = mapPoints.findLastIndex((point) => {
      return new Date(point.date) <= new Date(date);
    });

    onSetMapCenter({ lat: mapPoints[index].location[0], lng: mapPoints[index].location[1] });
    onSetCurrentPoint(mapPoints[index].index, date);
    onSetMessagesSelectDateDataState(date);
  }

  render() {
    const { isLoaded } = this.state;
    if (!isLoaded) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Preloader />
        </div>
      );
    }

    const { messagesData, dataState, onSetMessagesData, fullScreen } = this.props;

    return (
      <MessagesTable
        data={messagesData}
        dataState={dataState}
        onSetMessagesData={onSetMessagesData}
        handleClickRow={this.handleClickRow.bind(this)}
        height={fullScreen ? 400 : 290}
      />
    );
  }
}

export default withMapControl(
  withIntelligenceControl(withIntelligenceTimeRangePlayer(withMapPositions(withTimerangeIntelligence(withMessages(MessagesData)))))
);
